import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { provincesService } from '../../_services/provinces.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class CountrySelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      defaultValue: '',
      data: [],
      value: this.props.defaultValue || {},
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
    provincesService.getAll()
      .then((res) => {
        // console.log(res.data)
        let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      })
  };

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
    if (nextProps.defaultValue !== this.state.value) {

      this.setState({ value: nextProps.defaultValue });

    }
  }

  handleChange = e => {
    // console.log(e);

    this.props.onChange(e);
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f9f9f9',
        borderRadius: 7,
        // height: 40,
        boxShadow: 'none',
        border: '1px solid #e1e1e1',
        paddingRight: '12',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading, data, value } = this.state;
    const { disabled, className, isClearable } = this.props;


    return (
      <ReactSelect
        isClearable={isClearable}
        isDisabled={disabled}
        placeholder=""
        styles={customStyles}
        options={data}
        onChange={this.handleChange}
        value={value ? data.filter(el => el.value === value) : null}
        className={className ? className : "select"}
        isLoading={loading}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال دریافت اطلاعات از سرور"}
      />
    );
  }
}
export default CountrySelect;
